import { useEffect } from "react";
import { Camera, Images, X } from "lucide-react";
import { TAKE_PHOTO, CHOOSE_GALLERY } from "@/components/PhotoSourceButtons";

// The floor Photo tile asks which source — camera or gallery, both always offered, two big glove-size buttons.
export function FloorPhotoChoice({ open, onCamera, onGallery, onClose, testid }) {
  useEffect(() => {
    if (!open) return undefined;
    const esc = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [open, onClose]);
  if (!open) return null;
  const big = "w-full h-20 rounded-xl text-2xl font-black flex items-center justify-center gap-3 active:scale-95 transition-transform duration-100";
  return (
    <div className="fixed inset-x-0 top-vv h-vv z-50 bg-black/50 flex items-end sm:items-center justify-center sm:p-6"
      data-testid={testid} onClick={onClose}>
      <div className="bg-white w-full sm:max-w-md sm:rounded-2xl rounded-t-2xl p-4 flex flex-col gap-3" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <div className="font-display text-2xl font-black">Add a photo</div>
          <button type="button" data-testid={`${testid}-close`} onClick={onClose} aria-label="Close" className="p-1"><X className="w-7 h-7 text-slate-400" /></button>
        </div>
        <button type="button" data-testid={`${testid}-camera`} onClick={() => { onCamera(); onClose(); }}
          className={`${big} bg-[#B01E28] text-white active:bg-[#8B1820]`}>
          <Camera className="w-8 h-8" strokeWidth={2.2} />{TAKE_PHOTO.toUpperCase()}
        </button>
        <button type="button" data-testid={`${testid}-gallery`} onClick={() => { onGallery(); onClose(); }}
          className={`${big} border-2 border-slate-300 bg-white text-slate-800 active:bg-slate-50`}>
          <Images className="w-8 h-8" strokeWidth={2.2} />{CHOOSE_GALLERY.toUpperCase()}
        </button>
      </div>
    </div>
  );
}
